module.exports = __webpack_public_path__ + "static/media/14.14a7d658.png";